import script from "./SeatChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeatChip.vue?vue&type=script&setup=true&lang=ts"

import "./SeatChip.vue?vue&type=style&index=0&id=311ec310&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311ec310"]])

export default __exports__